export default __webpack_public_path__ + "static/media/thankYouImage.4a707f6e.png";